import React from 'react';
import { LogUtils } from '@repo/shared-utils/log-utils';
import { getMarketTodayData } from '../../services/TradingMallService';
import type { MarketTodayContent, MarketTodayApiResponse } from '../../interfaces/MarketToday.interface';
import MarketToday from './MarketToday';

interface MarketTodayServerProps {
  readonly content: MarketTodayContent;
}

/**
 * Server component wrapper for MarketToday
 * Fetches initial data server-side for SEO purposes
 * The client component handles updates and user interactions
 */
export default async function MarketTodayServer({ content }: MarketTodayServerProps) {
  let initialData: MarketTodayApiResponse | null = null;
  let initialModalData: MarketTodayApiResponse | null = null;
  let initialHasError = false;

  try {
    // Fetch initial data server-side for SEO
    // For non-logged-in users, this will be the default market data
    // For logged-in users, the client component will fetch personalized data
    const [marketData, modalData] = await Promise.all([
      getMarketTodayData(content.marketToday ?? 'mkt_today'),
      getMarketTodayData(content.marketTodayOptions ?? 'mkt_today_opts'),
    ]);

    initialData = marketData;
    initialModalData = modalData;
  } catch (error) {
    LogUtils.error('Error fetching initial market data:', error);
    // Continue with null data - client component will handle loading state
  }

  return (
    <MarketToday
      content={content}
      initialData={initialData ?? undefined}
      initialModalData={initialModalData ?? undefined}
      initialHasError={initialHasError}
    />
  );
}
